module.exports = __webpack_public_path__ + "static/media/about-us-press.52915fdd.png";